import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isLettere1qnx5bysxbd as isLetter } from '../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function termShouldUseFuzzySearch(_this__u8e3s4) {
  var tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.all' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (!(isLetter(element) || element === _Char___init__impl__6a9atx(45))) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  if (tmp$ret$1) {
    tmp = _this__u8e3s4.length > 3;
  } else {
    tmp = false;
  }
  return tmp;
}
//region block: exports
export {
  termShouldUseFuzzySearch as termShouldUseFuzzySearch1p8g0yvn86xll,
};
//endregion

//# sourceMappingURL=termShouldUseFuzzySearch.mjs.map
